import React, { useState, useEffect } from 'react';

import Header from "../../layouts/Header";
import Footer from "../../layouts/Footer";
import { Link , useParams, useNavigate, useLocation  } from "react-router-dom";
import {Links} from '../../routes/PathLink';
import { Table } from "../../components/ui/table";
import {
  useCompanyQuery
} from '../../data/company';
import {
  useStockPostQuery, 
  useStorePostMutation, 
  useLikePostMutation, 
  useStockPostInfiniteQuery,
  useRepostMutation,
  useReplyMutation,
  useReplyInfiniteQuery,
  useReportPost,
  useAllForumsInfiniteQuery,
  useForumKingQuery,
  useForumPopularQuery
} from '../../data/forum-details';
import { cleanCompanyName, formatPostTime, toast_anim , toast_anim_error} from "../../components/config/Common";
import {APP_URL, APP_NAME} from 'components/config/Common'
import Seo from 'components/seo/seo'
import Breadcrumb  from "../../components/Breadcrumb";
import { MdOutlineWatchLater, MdReportProblem } from "react-icons/md";

import TextArea  from "../../components/ui/text-area";
import Input from '../../components/ui/input.jsx';
import Button from 'components/ui/Button.tsx'
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import {
   Control,
   FieldErrors,
   useForm,
   useFormState,
   useWatch,
   Controller
 } from 'react-hook-form';
 import { useQueryClient } from "@tanstack/react-query";

import { BiLike, BiRepost } from "react-icons/bi";
import { BsFillReplyFill, BsSearch } from "react-icons/bs";
import { GoLinkExternal } from "react-icons/go";

import LoginwithEmail from "components/auth/user/LoginwithEmail";
import SocialLogin from "components/auth/SocialLogin";
import ModalView from '_utils/ModalView'

 const SignupSchema = Yup.object().shape({
     content: Yup.string()
           .required('You must need to provide your content.')
           .test(
            "min-words",
            "Your post must contain at least 10 words.",
            (value) => {
              if (!value) return false;

              const words = value
                .trim()
                .split(/\s+/)   // split by spaces, tabs, newlines
                .filter(Boolean);

              return words.length >= 10;
            }
          ),
 });
 
 const defaultValues = {     
    content:'',
  };

const ForumHome = () => {
  const queryClient = useQueryClient();

    const navigate = useNavigate();
    const {slug} = useParams()
    const [access_token,setAccess_token] = useState(localStorage.getItem('access_token'));
    const [isLogin, setIsLogin] = useState(false)
    //console.log('symbol===',slug)

    const [metaTitle, setMetaTitle] = useState('Stock Market Forums')
    const [metaDesc, setMetaDesc] = useState('Join our stock market forum to discuss shares, companies, trading strategies, and investment ideas. Connect with investors and stay updated with market trends.')

    const [openReply, setOpenReply] = useState(false);
    const [replyText, setReplyText] = useState("");
    const [openReplies, setOpenReplies] = useState(false);
    const [postReplyId, setPostReplyId] = useState();
    const [openPostId, setOpenPostId] = useState(null);
    const [activeReplyPostId, setActiveReplyPostId] = useState(null);
    const [openReportPostId, setOpenReportPostId] = useState(null);
    const [reason, setReason] = useState("");
    const [open, setOpen] = useState(false);
    const [searchQuery, setSearchQuery] = useState(null);

    const openPopup = () => {
      setOpen(true);
    };

    useEffect(() => {
        if(access_token){
            setIsLogin(true)
        }
    }, [access_token])

    const {
        data:forumKing,
        isLoading:kingLoading,
    } = useForumKingQuery();

    const {
        data:forumPopular,
        isLoading:popularLoading,
    } = useForumPopularQuery();

    //console.log('forumPopular=====>', forumPopular)
    

    const { mutate: report } = useReportPost();

    useEffect(() => {
      if (openPostId) {
        queryClient.removeQueries(["post-replies", openPostId]);
      }
    }, [openPostId]);

    

    const {
        data,
        fetchNextPage,
        hasNextPage,
        isLoading,
        isFetchingNextPage,
    } = useAllForumsInfiniteQuery({
        sq:searchQuery,
        limit: 10,
          // 🚀 wait until company is loaded
     });



     const posts = data?.pages?.flatMap(page => page.data) || [];
     const checkPost = Array.isArray(posts) ? posts.filter(Boolean) : [];

     const safeData = data?.pages?.flatMap(page => page.company) || null;
     const searchRes = Array.isArray(safeData) ? safeData.filter(Boolean) : [];

     console.log('forums====', posts)

     /* const {
      data: replyData,
      fetchNextPage: fetchNextReplies,
      hasNextPage: hasMoreReplies,
      isFetchingNextPage: loadingReplies,
    } = useReplyInfiniteQuery({
      postId: openPostId,
      enabled: !!openPostId
    }); */

    const {
      data: replyData,
      fetchNextPage: fetchNextReplies,
      hasNextPage: hasMoreReplies,
      isFetchingNextPage: loadingReplies
    } = useReplyInfiniteQuery({
      postId: openPostId,
      enabled: !!openPostId
    });

//console.log('hasMoreReplies', hasMoreReplies)

    //const replies =  replyData?.pages?.flatMap(p => p.data) || [];
    const replies = replyData?.pages.flatMap(p => p.data) || [];

     //console.log("replies data====",replies)

     useEffect(() => {
      const onScroll = () => {
        if (
          window.innerHeight + window.scrollY >=
          document.body.offsetHeight - 200 &&
          hasNextPage
        ) {
          fetchNextPage();
        }
      };

      window.addEventListener("scroll", onScroll);
      return () => window.removeEventListener("scroll", onScroll);
    }, [hasNextPage]);

     

     //console.log('post====', records)
    
    const { register, handleSubmit , control, reset, setValue, setError, formState: { errors },} = useForm({
      defaultValues: defaultValues,
      resolver: yupResolver(SignupSchema),
      shouldFocusError:false,
    });

    

    const { mutate: repost } = useRepostMutation();

    const { mutate: toggleLike } = useLikePostMutation();

    const togglePostLike = (postId) => {
        toggleLike(
          postId,
          {
          onError: (error) => {
            console.log("errors===",error.message);
            let err = error?.response?.data?.message || "Something went wrong";
            toast_anim_error(err);
            
            
          },
          onSuccess: (data) => {
           console.log("Data REsponse ",data);
           //reset({ content: "" });
            if(data?.status == 200){
              toast_anim(data?.message);
            }
            
          },
          }
        )
    }

    const handleLikeClick = (postId) => {
      if (!isLogin) {
        openPopup();   // login modal
        return;
      }

      togglePostLike(postId);
    };

    const handleReplyClick = (postId) => {
      if (!isLogin) {
        openPopup();   // login modal
        return;
      }

      setActiveReplyPostId(postId);
    };

    const handleRepostClick = (postId) => {
      if (!isLogin) {
        openPopup();   // login modal
        return;
      }

      repost(postId);
    }
    const handleReportClick = (postId) => {
      if (!isLogin) {
        openPopup();   // login modal
        return;
      }

      setOpenReportPostId(postId);
    }

    const breadcrumb = [
      {
        name:'Home',
        link:`${process.env.REACT_APP_URL}`,
      },
      {
        name:`${metaTitle}`,
        link:null
      },
    ]

    const SkeletonPost = () => (
      <div className="bg-white p-4 rounded shadow animate-pulse">
        <div className="h-4 bg-gray-200 w-1/4 mb-2 rounded"></div>
        <div className="h-3 bg-gray-200 w-full mb-2 rounded"></div>
        <div className="h-3 bg-gray-200 w-3/4 rounded"></div>
      </div>
    );

    const { mutate: reply } = useReplyMutation();

    const sendReply = (postId, text) => {
      if (!text.trim()) return;
      //console.log("replay===",text)
      reply({ postId, content: text });
      setReplyText("");
      setOpenReply(false);
    };

    const send_report = (post_id) => {
      //console.log('reason======',reason)
      report({
          post_id: post_id,
          reason
        },
        {
          onSuccess: (data) => {
           //console.log("Data report ",data);
           if(data?.status == 200){
              toast_anim(data?.message);
              setReason("")
              setOpenReportPostId(null);
            }
          },
          onError: (error) => {
            //console.log("report errors===",error?.response?.data);
            let err = error?.response?.data?.message || "Something went wrong";
            toast_anim_error(err);
            
            
          },
        }
        
      );
      
    }

    const searchForum = (val) => {
      //console.log('sq---', val)
      setSearchQuery(val)
    }

    const highlightText = (text, searchTerm) => {
      if (!searchTerm) return text;

      // Split by space & remove empty values
  const words = searchTerm
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .filter(word => word.length > 2)
    .map(word =>
      word.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
    );

  if (!words.length) return text;

  const regex = new RegExp(`(${words.join("|")})`, "gi");

  return text.split(regex).map((part, index) =>
    regex.test(part) ? (
      <strong
        key={index}
        className="text-yellow-500 group-hover:text-accent"
      >
        {part}
      </strong>
    ) : (
      part
    )
  );
    };

    return (
        <>
            <Seo 
                title={`${metaTitle} | Discuss Shares & Companies - ${APP_NAME}`}
                desc={metaDesc && metaDesc.substring(0, 200)}
                url={`${APP_URL}/forums`}
            />  
            <Header  />
            <div className='px-5'>
              {<Breadcrumb breadcrumb={breadcrumb} />}
              <h2 className="text-2xl pt-5">{metaTitle}</h2>
              <div className='my-3'>{metaDesc}</div>
            </div>
            <div className="w-full px-5 flex flex-col lg:flex-row gap-10">
                
                <section className="w-full lg:w-[60%] order-2 lg:order-1">
                    <div className="relative bg-white px-5 pb-5 pt-2 mb-5 shadow rounded border border-gray-300">
                      <div className="absolute inset-y-0 left-5 top-0 flex items-center pl-3 pointer-events-none">
                      <BsSearch className="w-5 h-5 text-gray-400" />
                    </div>
                    <Input 
                      dimension='small' 
                      onChange={(e) => searchForum(e.target.value)} 
                      value={searchQuery}
                      placeholder='Search by company, user or content...'
                      
                      inputClassName="!px-12"
                    />
                    </div>
                    
                    {isLoading && (
                      <div className="space-y-4 p-4">
                        {[...Array(5)].map((_, i) => (
                          <SkeletonPost key={i} />
                        ))}
                      </div>
                    )}

                    {
                      !isLoading && searchQuery && checkPost?.length <= 0 ? 
                      <div className="bg-white shadow rounded mb-5 border border-gray-300 p-4">
                        No discussions found for <strong>'{searchQuery}'</strong> yet.
                        {
                          searchRes?.length > 0 &&                           
                        <>
                        <div className='my-2'>Be the first to start the conversation!</div>
                        <div className='flex flex-wrap gap-3'>
                        {                          
                          searchRes?.map((val, key) => (
                            <Link className='group capitalize border border-accent px-3 py-1 rounded text-sm hover:text-accent' key={`search-${key}`} to={`${process.env.REACT_APP_URL}${Links.COMPANY}/${val?.symbol}/forum`}>{highlightText(val?.name, searchQuery)}</Link>
                          ))
                        }    
                        </div>                    
                        </>
                        }
                      </div> 
                      :null
                    }
                    
                    {
                    !isLoading && searchRes?.length <= 0 && checkPost?.length > 0 && posts?.map(rec=>(

                    <div className="bg-white shadow rounded mb-5 border border-gray-300">
                      <div className='flex items-center gap-3 px-4 pt-3 text-lg'>
                      <h2 >{highlightText(cleanCompanyName(rec?.company?.name),searchQuery)}</h2>
                      <Link className="text-black" target="_blank" to={`${process.env.REACT_APP_URL}${Links.COMPANY}/${rec?.company?.symbol}/forum`}><GoLinkExternal /></Link>
                      </div>

                      <div className='p-4'>
                        
                        
                        <div className='flex items-center justify-between'>
                          <div className="text-xs font-semibold py-3">{highlightText(rec?.user?.name,searchQuery)}</div>
                          <div className="flex gap-1 items-center text-xs text-gray-500">
                            <MdOutlineWatchLater /> <div>{formatPostTime(rec?.created_at)}</div>
                          </div>
                        </div>
                        {rec?.repost_id ? (
                          <div className="bg-gray-100 p-4 rounded text-sm">
                            <div className='pb-3'>🔁 Reposted from <b>{highlightText(rec?.reposted_post?.user.name, searchQuery)}</b></div>
                            <div className="text-sm text-body whitespace-pre-line break-words">{highlightText(rec?.reposted_post?.content,searchQuery)}</div>
                          </div>
                        ) :                        
                        <div className="text-sm text-body whitespace-pre-line break-words">
                          {highlightText(rec?.content,searchQuery)}
                        </div>
                        }

                        {rec?.replies?.map(r=>(
                          <div className="ml-6 mt-2 border-l pl-3">
                            <div className='flex items-center justify-between'>
                              <div className="text-xs font-semibold py-3">{highlightText(r?.user?.name, searchQuery)}</div>
                              <div className="flex gap-1 items-center text-xs text-gray-500">
                                <MdOutlineWatchLater /> <div>{formatPostTime(r?.created_at)}</div>
                              </div>
                            </div>
                            <div className='text-sm text-body whitespace-pre-line break-words'>{highlightText(r?.content,searchQuery)}</div>
                            
                          </div>
                        ))}
                        {openPostId === rec?.id && replies.map(r => (
                          <div className="ml-6 mt-2 border-l pl-3">
                            <div className='flex items-center justify-between'>
                              <div className="text-xs font-semibold py-3">{highlightText(r?.user?.name,searchQuery)}</div>
                              <div className="flex gap-1 items-center text-xs text-gray-500">
                                <MdOutlineWatchLater /> <div>{formatPostTime(r?.created_at)}</div>
                              </div>
                            </div>
                            <div className='text-sm text-body whitespace-pre-line break-words'>{r?.content}</div>
                            
                          </div>
                        ))}
                        {/* {openPostId === rec?.id && hasMoreReplies && (
                          <button onClick={fetchNextReplies}>
                            {loadingReplies ? "Loading..." : "Load more replies"}
                          </button>
                        )} */}
                        {/* {openPostId === rec.id && hasMoreReplies && (
                          <button onClick={fetchNextReplies}>
                            {loadingReplies ? "Loading..." : "Load more replies"}
                          </button>
                        )}
                        {rec.replies_count > 5 && openPostId !== rec.id && (
                          <button onClick={() => setOpenPostId(rec.id)}>
                            View all replies ({rec.replies_count})
                          </button>
                        )} */}

                      </div>
                      <div className='bg-gray-300 text-sm mt-2 p-3 flex items-center justify-between'>
                        <div className="flex gap-4">
                          <button
                            onClick={() => handleLikeClick(rec?.id)}
                            className={`flex items-center gap-1 ${
                              rec?.user_liked ? "text-blue-600" : "text-gray-500"
                            }`}
                          >
                            <BiLike className='text-lg' /> Like {rec?.likes_count || null }
                          </button>

                          <button className="flex items-center gap-1 text-gray-500" onClick={() => handleReplyClick(rec?.id)}><BsFillReplyFill className='text-xl' /> Reply {rec?.replies_count || null}</button>
                          {/* <button className="flex items-center gap-1 text-gray-500" onClick={() => handleRepostClick(rec?.id)}><BiRepost className='text-xl' /> Repost {rec?.reposts_count || null}</button> */}
                        </div>
                        <div>
                          <button className="flex items-center gap-1 text-gray-500" onClick={() => handleReportClick(rec?.id)}><MdReportProblem  className='text-lg' /> Offensive</button>
                        </div>
                      </div>
                      {activeReplyPostId === rec?.id && (
                        <div className="mt-2 p-3 border rounded bg-gray-50">
                          <TextArea
                            value={replyText}
                            onChange={e => setReplyText(e.target.value)}
                            placeholder="Write a reply..."
                            rows={3}
                          />

                          <Button
                            onClick={() => sendReply(rec?.id, replyText)}
                            className="my-2" 
                            
                            size="small"
                          >
                            Reply
                          </Button>
                        </div>
                      )}

                      {openReportPostId === rec?.id && (
                        <div className="fixed inset-0 bg-black/30 flex justify-center items-center">
                          <div className="bg-white p-4 w-96 rounded">
                            <h3 className="font-bold mb-3">Why is the message offensive?</h3>
                            <div className='mb-3 text-xs'>Please click on the reason below to notify the modeeating team. Marking good messages offensive will put you on the moderating team's radar.</div>
                            {[
                              "Personal attacks",
                              "Insensitive references",
                              "Deliberate outrage",
                              "Verbal threats",
                              "Offensive language",
                              "Misinformation",
                              "Spam",
                              "Commercial promotion",
                              "Malicious intent"
                            ].map(r => (
                              <label key={r} className="block mb-2 text-sm flex items-center gap-2">
                                <input
                                  type="radio"
                                  name="reason"
                                  onChange={() => setReason(r)}
                                  className='checked:bg-accent focus:ring-accent'
                                /> {r}
                              </label>
                            ))}

                            <div className="flex justify-end gap-2 mt-4">
                              <button onClick={() => setOpenReportPostId(null)}>Cancel</button>
                              <button
                                onClick={() => send_report(rec?.id)}
                                className="bg-blue-600 text-white px-4 py-1"
                              >
                                Submit
                              </button>
                            </div>
                          </div>
                        </div>
                      )}

                    </div>
                    ))}
                    {isFetchingNextPage && (
                      <div className="mt-4 space-y-4">
                        {[...Array(3)].map((_, i) => (
                          <SkeletonPost key={i} />
                        ))}
                      </div>
                    )}
                    {!isLoading && !isFetchingNextPage && !hasNextPage && posts.length > 0 && (
                      <p className="text-center text-gray-400 text-sm mt-6">
                        You've reached the end
                      </p>
                    )}
                </section>
                <section className="w-full lg:w-[38%] order-1 lg:order-2">
                    <div className='bg-white shadow rounded border border-gray-300'>
                      <div className='px-5 pt-3'>MOST DEBATED/POPULAR</div>
                      {popularLoading && (
                        <div className="space-y-4 p-4">
                          {[...Array(1)].map((_, i) => (
                            <SkeletonPost key={i} />
                          ))}
                        </div>
                      )}
                    
                      <div className='p-5 flex flex-wrap gap-3'>
                        {
                          forumPopular && forumPopular.map((val, key) => (
                            <Link to={`${APP_URL}${Links.COMPANY}/${val?.company?.symbol}/forum`}><div className='capitalize border border-accent px-3 py-1 rounded text-sm hover:text-accent'>{cleanCompanyName(val?.company?.name)}</div></Link>
                          ))
                        }
                      </div>
                    </div>
                    <div className='bg-white shadow rounded border border-gray-300 my-5'>
                      <div className='px-5 pt-3'>FORUM KING</div>
                        {kingLoading && (
                        <div className="space-y-4 p-4">
                          {[...Array(1)].map((_, i) => (
                            <SkeletonPost key={i} />
                          ))}
                        </div>
                      )}
                      <div className='p-5 flex flex-wrap gap-3'>
                        
                        {
                          forumKing && forumKing.map((val, key) => (
                            <div className='capitalize border border-accent px-3 py-1 rounded text-sm'>{val?.user?.name}</div>
                          ))
                        }
                      </div>
                    </div>
                </section>
            </div>
            <ModalView open={open} onClose={() => setOpen(false)}>
              <div className="flex flex-col justify-center">
                  <div className="text-center text-base text-body">Don't have an account? <Link to={`${Links.USER_SIGNUP}`} className="text-accent underline transition-colors duration-200 hover:text-accent-hover hover:no-underline focus:text-accent-hover focus:no-underline focus:outline-none ltr:ml-1 rtl:mr-1">Create New</Link></div>
                  
                </div>  
              <LoginwithEmail goTo={window.location.href} />
              <SocialLogin mode='Login' user_type='user' goTo={window.location.href} />
            </ModalView>
            <Footer />
        </>
    );
}
export default ForumHome;
